import { MemberCardWithConnectionSkeleton } from "./MemberCardWithConnectionSkeleton";

const DEFAULT_ITEM_COUNT = 6;

interface CardViewSkeletonProps {
  count?: number;
}

export const CardViewSkeleton = ({
  count = DEFAULT_ITEM_COUNT,
}: CardViewSkeletonProps) => (
  <ol
    className="m-4 grid w-full list-none auto-rows-fr grid-cols-[repeat(auto-fit,235px)] gap-5 md:m-0 lg:m-auto"
    data-testid="directory_members_grid_skeleton"
  >
    {Array.from({ length: count }).map((_, index) => (
      // eslint-disable-next-line react/no-array-index-key -- No need to use a unique key
      <MemberCardWithConnectionSkeleton key={index} />
    ))}
  </ol>
);
